"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportSection = void 0;
const tslib_1 = require("tslib");
const customIndicatorSection_1 = require("./customIndicatorSection");
const commentSection_1 = require("./commentSection");
const patientEndSection_1 = require("./patientEndSection");
const patientInfoSection_1 = require("./patientInfoSection");
const patientNotesSection_1 = require("./patientNotesSection");
const defaultIndicatorSection_1 = require("./defaultIndicatorSection");
const submissionSection_1 = require("./submissionSection");
function exportSection(db, organization, sectionSchema, schemas, patients, options, start, end) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if ('exclude' in sectionSchema && sectionSchema.exclude) {
            return null;
        }
        if (sectionSchema.type === 'action') {
            return (0, submissionSection_1.makeSubmissionSection)(db, sectionSchema, patients, schemas[sectionSchema.workflow.toString()], start, end);
        }
        else if (sectionSchema.type === 'form') {
            return (0, submissionSection_1.makeSubmissionSection)(db, sectionSchema, patients, schemas[sectionSchema.form.toString()], start, end);
        }
        else if (sectionSchema.type === 'ongoing') {
            // return makeOngoingSection()
            throw new Error(`type: ongoing is not supported yet`);
        }
        else if (sectionSchema.type === 'comment') {
            return (0, commentSection_1.makeCommentSection)(sectionSchema);
        }
        else if (sectionSchema.type === 'end') {
            return (0, patientEndSection_1.makePatientEndSection)(patients);
        }
        else if (sectionSchema.type === 'indicator') {
            return makeIndicatorSection(db, organization, sectionSchema, patients, options);
        }
        else if (sectionSchema.type === 'info') {
            return (0, patientInfoSection_1.makePatientInfoSection)(db, sectionSchema, patients);
        }
        else if (sectionSchema.type === 'notes') {
            return (0, patientNotesSection_1.makePatientNotesSection)(db, sectionSchema, patients, start, end);
        }
        throw new Error(`Received unknown section type of ${sectionSchema.type}`);
    });
}
exports.exportSection = exportSection;
function makeIndicatorSection(db, organization, sectionSchema, patients, options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if ('custom' in sectionSchema && sectionSchema.custom) {
            const customIndicator = yield db.get.customIndicator(organization, sectionSchema.indicator);
            if (!customIndicator)
                throw new Error(`Could not find custom indicator with ID ${sectionSchema.indicator}`);
            return (0, customIndicatorSection_1.makeCustomIndicatorSection)(db, patients, sectionSchema, customIndicator, options);
        }
        else {
            return (0, defaultIndicatorSection_1.makeDefaultIndicatorSection)(db, patients, sectionSchema);
        }
    });
}
//# sourceMappingURL=index.js.map